export default __webpack_public_path__ + "static/media/Filosofia.2d9f721b.pdf";